// BetaRobotNode.tsx
//
// BetaRobotNode is a robot movable item.

import * as React from 'react';

export default function BetaRobotNode(): React.ReactElement | null {
	return <div className="BetaRobotNode" />;
}
